import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-save-box',
  templateUrl: './save-box.component.html',
  styleUrls: ['./save-box.component.scss']
})
export class SaveBoxComponent {
  @Input() absolute: boolean;
  @Input() areButtonsEnabled = false;
  @Input() resetText = "Reset";
  @Output() onSave =  new EventEmitter();
  @Output() onReset =  new EventEmitter();

  constructor() { }

  reset() {
    this.onReset.emit();
  }

  save() {
    this.onSave.emit();
  }
}
